import { createFileRoute } from "@tanstack/react-router";
import { GeneralForm } from "../../components/app/settings/GeneralForm";
import { ProfileForm } from "../../components/app/settings/ProfileForm";
import { DangerZone } from "../../components/app/settings/DangerZone";
import { Trans } from "@lingui/react/macro";
import { OrganizationList } from "../../components/app/settings/OrganizationList";
import { useAuth } from "@/hooks/useAuth";
import { useMemo } from "react";

export const Route = createFileRoute("/app/settings")({
  component: RouteComponent,
});

function RouteComponent() {
  const session = useAuth();

  const userId = useMemo(() => {
    return session.data?.user?.id;
  }, [session]);

  const userName = useMemo(() => {
    return session.data?.user?.name;
  }, [session]);

  const userAvatar = useMemo(() => {
    return session.data?.user?.image;
  }, [session]);

  return (
    <div className="flex h-full w-full items-start py-12">
      <div className="container w-full max-w-[576px] flex flex-col items-center gap-6 self-stretch bg-default-background mx-auto">
        <div className="flex w-full flex-col items-start gap-12">
          <div className="flex w-full flex-col items-start gap-1">
            <span className="w-full text-heading-2 font-heading-2 text-default-font">
              <Trans>Account Settings</Trans>
            </span>
            <span className="w-full text-body font-body text-subtext-color">
              <Trans>Update your profile and personal details here</Trans>
            </span>
          </div>
          <GeneralForm />
          <div className="flex h-px w-full flex-none flex-col items-center gap-2 bg-neutral-border" />
          <ProfileForm
            id={userId}
            name={userName}
            avatar={userAvatar ?? undefined}
          />
          <div className="flex h-px w-full flex-none flex-col items-center gap-2 bg-neutral-border" />
          {/* <AuthenticationForm />
          <div className="flex h-px w-full flex-none flex-col items-center gap-2 bg-neutral-border" /> */}
          <OrganizationList />
          <div className="flex h-px w-full flex-none flex-col items-center gap-2 bg-neutral-border" />
          <DangerZone />
        </div>
      </div>
    </div>
  );
}
